var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-textarea',_vm._g({ref:_vm.refInput,class:[
    _vm.state ? 'border-danger bg-danger-outline' : '',
    _vm.classCustom ? _vm.classCustom : '',
    'overflow-auto'
  ],attrs:{"id":_vm.id,"type":"text","disabled":_vm.disabled,"autofocus":_vm.autofocus,"placeholder":_vm.placeholder,"title":_vm.title,"rows":"3"},on:{"input":_vm.onInput,"keydown":_vm.onkeydown,"paste":_vm.onPaste,"blur":_vm.onBlur},model:{value:(_vm._dataModel),callback:function ($$v) {_vm._dataModel=$$v},expression:"_dataModel"}},_vm.$listeners))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76722bc8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/custom-components/InputTextAreaComponent.vue
// module id = null
// module chunks = 